module.exports = __webpack_public_path__ + "img/sun.9d7be802.svg";